import { render, staticRenderFns } from "./rutini-wines.vue?vue&type=template&id=b882b4cc&scoped=true"
import script from "./rutini-wines.vue?vue&type=script&lang=js"
export * from "./rutini-wines.vue?vue&type=script&lang=js"
import style0 from "./rutini-wines.vue?vue&type=style&index=0&id=b882b4cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b882b4cc",
  null
  
)

export default component.exports